import { defineMessages } from '@atlassian/jira-intl';

const i18n = defineMessages({
	projectLeadFieldLabel: {
		id: 'project-details.form.project-lead.project-lead-field-label',
		defaultMessage: 'Project lead',
		description: 'Label for Project Lead Field',
	},
	projectLeadHelpText: {
		id: 'project-details.form.project-lead.project-lead-help-text',
		defaultMessage: 'Make sure your project lead has access to issues in the project.',
		description:
			'It is an interim helptext asking users to select project lead who is assignable. We will be validating this field in future.',
	},
});

export default i18n;
